import { BehaviorSubject } from 'rxjs';
import sortBy from 'lodash.sortby';
export const getAuthStore = () => {
    const getInitialState = () => ({
        isLoggedIn: false,
        currentUser: {
            id: null,
            username: null,
            firstName: null,
            lastName: null,
            email: null,
            accessDetails: [],
            clientFeatures: [],
            unreadNotifications: 0
        },
        isAppLoading: true,
        hasError: false
    });
    const authSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => authSubject.subscribe(callback);
    const login = (currentUserAccount) => {
        authSubject.next({
            ...authSubject.getValue(),
            isLoggedIn: true,
            currentUser: {
                id: currentUserAccount.homeAccountId,
                username: currentUserAccount.username,
                firstName: '',
                lastName: '',
                email: '',
                accessDetails: [],
                clientFeatures: [],
                unreadNotifications: 0
            }
        });
    };
    const logout = () => {
        authSubject.next(getInitialState());
    };
    const setIsAppLoading = (value) => authSubject.next({ ...authSubject.getValue(), isAppLoading: value });
    const setHasError = (value) => authSubject.next({ ...authSubject.getValue(), hasError: value });
    const updateUserAccessDetails = (details) => {
        authSubject.next({
            ...authSubject.getValue(),
            currentUser: {
                ...authSubject.getValue().currentUser,
                firstName: details.firstName,
                lastName: details.lastName,
                email: details.email,
                accessDetails: sortBy(details.userClientCompanyAssociations, ['roleId', 'clientId', 'companyId']),
                clientFeatures: details.clientFeatures,
                unreadNotifications: details.unreadNotifications
            }
        });
    };
    const getCurrentUsername = () => authSubject.getValue().currentUser.username;
    const getIsLoggedIn = () => authSubject.getValue().isLoggedIn;
    const getCurrentUserRoles = () => authSubject.getValue().currentUser.accessDetails.map((item) => item.roleId);
    const getCurrentUserClientCompanyAssociations = () => authSubject.getValue().currentUser.accessDetails;
    const getCurrentUserClientFeatures = () => authSubject.getValue().currentUser.clientFeatures;
    const getCurrentUser = () => authSubject.getValue().currentUser;
    return {
        getInitialState,
        subscribe,
        login,
        logout,
        updateUserAccessDetails,
        getCurrentUsername,
        getIsLoggedIn,
        getCurrentUserRoles,
        getCurrentUserClientCompanyAssociations,
        getCurrentUserClientFeatures,
        setIsAppLoading,
        setHasError,
        getCurrentUser
    };
};
